<template>
  <div class="container">
    <!--司机完成订单子页面-->
    <el-button type="success" icon="el-icon-download">数据导出</el-button>
    <el-table :data="tableData" height="500" border class="table">
      <el-table-column
        align="center"
        label="订单号"
        prop="orderNo"
        width="200"
      ></el-table-column>
      <el-table-column
        align="center"
        label="订单类型"
        prop="typeStr"
        width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        label="订单来源"
        prop="orderSourceStr"
        width="100"
      ></el-table-column>
      <el-table-column
        :formatter="dateFormat"
        align="center"
        label="下单时间"
        prop="orderTime"
        width="150"
      ></el-table-column>
      <el-table-column
        :formatter="dateFormat"
        align="center"
        label="完成时间"
        prop="orderCompleteTime"
        width="150"
      ></el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: "driverComplateOrder",
  data() {
    return {
      tableData: [],
      form: {
        driverId: "",
        completeTime: ""
      }
    };
  },
  created(){
      this.form.driverId=this.$route.query.driverId
      this.form.completeTime=this.$route.query.completeTime
      this.getDate();

  },
  methods:{
      getDate(){
          this.$post("pc_order/queryDriverCompleteOrder",this.form)
          .then((response)=>{
              if(response.data.code===0){
                  this.tableData=response.data.data;
              }else{
                  console.log(response.data.msg);
              }
          })
          .catch((error)=>{
              console.log(error.message);
          })
      }
  }

  
};
</script>
<style scope>
</style>


// WEBPACK FOOTER //
// src/views/driver/DriverComplateOrder.vue